import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowUp } from '@fortawesome/pro-light-svg-icons';
import RQCalendarStyle from '../../../../common/styles/RQCalendar.module.css';
import classNames from 'classnames';
import { isIE, isEdge } from '../../../../common/utilities/browserDetection';
import { withTranslation } from 'react-i18next';

const HeaderContainer = styled.div`
    color: #8e8e8e;
    font-weight: 500;
    height: 25px;
    text-align: left;
    margin-left: 10px;
    position: relative;
    display: flex;
    border-top: 1px solid #E6EDF5;
    border-bottom: 1px solid #E6EDF5;
    padding-bottom: 15px;
    height: fit-content;
    padding: ${props => (isIE() || isEdge()) ? `15px 0 40px 0;` : `15px 0;`}
    margin-top: 20px;
`
const Name = styled.div`
    width: 15%;
`
const Warning = styled.div`
    width: 10%;
`
const Desc = styled.div`
    width: 15%;
`
const CreationHyperFindQuery = styled.div`
    width: 15%;
`
const ManagementHyperFindQuery = styled.div`
    width: 15%;
`
const RequestType = styled.div`
    width: 10%;
`
const RequestSubtype = styled.div`
    width: 10%;
`
const ApprovalProcess = styled.div`
    width: 10%;
`
const pointer = {
    cursor: 'pointer'
}

const SettingHeader = (props) => {
    let { t } = props;
    let icon = props.sortOrder === 'Ascending' ? faArrowUp : faArrowUp;

    return (
        <HeaderContainer >
            <Name>
                <div style={pointer} onClick={() => { props.sortBy('name') }}>
                    {t('settings.name')}
                    {props.sortBySelected === 'name' ? <FontAwesomeIcon className={classNames(props.sortOrder === 'Ascending' ? '' : RQCalendarStyle.Descending, RQCalendarStyle.Ascending)} icon={icon} /> : <React.Fragment></React.Fragment>}
                </div>
            </Name>
            <Warning>
                <div style={pointer} onClick={() => { props.sortBy('warnings') }}>
                    {t('settings.warning')}
                    {props.sortBySelected === 'warnings' ? <FontAwesomeIcon className={classNames(props.sortOrder === 'Ascending' ? '' : RQCalendarStyle.Descending, RQCalendarStyle.Ascending)} icon={icon} /> : <React.Fragment></React.Fragment>}
                </div>
            </Warning>
            <Desc>
                <div style={pointer} onClick={() => { props.sortBy('description') }}>
                    {t('settings.description')}
                    {props.sortBySelected === 'description' ? <FontAwesomeIcon className={classNames(props.sortOrder === 'Ascending' ? '' : RQCalendarStyle.Descending, RQCalendarStyle.Ascending)} icon={icon} /> : <React.Fragment></React.Fragment>}
                </div>
            </Desc>
            <ApprovalProcess>
                <div style={pointer} onClick={() => { props.sortBy('autoApproval') }}>
                    {t('settings.approvalProcess')}
                    {props.sortBySelected === 'autoApproval' ? <FontAwesomeIcon className={classNames(props.sortOrder === 'Ascending' ? '' : RQCalendarStyle.Descending, RQCalendarStyle.Ascending)} icon={icon} /> : <React.Fragment></React.Fragment>}
                </div>
            </ApprovalProcess>
            <RequestType>
                <div style={pointer} onClick={() => { props.sortBy('actionType') }}>
                    {t('settings.requestType')}
                    {props.sortBySelected === 'actionType' ? <FontAwesomeIcon className={classNames(props.sortOrder === 'Ascending' ? '' : RQCalendarStyle.Descending, RQCalendarStyle.Ascending)} icon={icon} /> : <React.Fragment></React.Fragment>}
                </div>
            </RequestType>
            <RequestSubtype>
                <div style={pointer} onClick={() => { props.sortBy('requestSubtype') }}>
                    {t('settings.requestSubtype')}
                    {props.sortBySelected === 'requestSubtype' ? <FontAwesomeIcon className={classNames(props.sortOrder === 'Ascending' ? '' : RQCalendarStyle.Descending, RQCalendarStyle.Ascending)} icon={icon} /> : <React.Fragment></React.Fragment>}
                </div>
            </RequestSubtype>
            <CreationHyperFindQuery>
                <div style={pointer} onClick={() => { props.sortBy('creationHyperfindId') }}>
                    {t('settings.creationHyperfind')}
                    {props.sortBySelected === 'creationHyperfindId' ? <FontAwesomeIcon className={classNames(props.sortOrder === 'Ascending' ? '' : RQCalendarStyle.Descending, RQCalendarStyle.Ascending)} icon={icon} /> : <React.Fragment></React.Fragment>}
                </div>
            </CreationHyperFindQuery>
            <ManagementHyperFindQuery>
                <div style={pointer} onClick={() => { props.sortBy('managementHyperfindId') }}>
                    {t('settings.managementHyperfind')}
                    {props.sortBySelected === 'managementHyperfindId' ? <FontAwesomeIcon className={classNames(props.sortOrder === 'Ascending' ? '' : RQCalendarStyle.Descending, RQCalendarStyle.Ascending)} icon={icon} /> : <React.Fragment></React.Fragment>}
                </div>
            </ManagementHyperFindQuery>
        </HeaderContainer>
    );
};
export default withTranslation('employmentBillboard')(SettingHeader);